import * as React from "react";
import FieldRow from "../../molecules/FieldRow";
import { ExtractedDataField } from "../../../../../types/dataTypes";

interface FieldsListProps {
  fields: ExtractedDataField[];
  schemaId: string;
  onViewField?: (field: ExtractedDataField) => void;
  onMapToWord?: (field: ExtractedDataField) => void;
  onValidateField?: (fieldId: string, isValid: boolean | null) => void;
  onFieldUpdate?: (fieldId: string, newValue: string) => void;
  className?: string;
}

const FieldsList: React.FC<FieldsListProps> = ({ 
  fields, 
  schemaId,
  onViewField, 
  onMapToWord,
  onValidateField,
  onFieldUpdate,
  className = ''
}) => {
  if (!fields || fields.length === 0) {
    return null;
  }

  return (
    <div className={`mt-3 md:mt-4 ${className}`}>
      <h4 className="text-[13px] font-semibold text-slate-700 mb-2.5 md:text-sm md:mb-3">
        Campos Extraídos ({fields.length})
      </h4>
      <div className="flex flex-col gap-0">
        {fields.map((field, index) => (
          <FieldRow
            key={field.id}
            field={field}
            schemaId={schemaId}
            onView={onViewField}
            onMapToWord={onMapToWord}
            onValidate={onValidateField}
            onFieldUpdate={onFieldUpdate}
            className={index === fields.length - 1 ? "last-field" : ""}
            style={index === fields.length - 1 ? { marginBottom: 0 } : undefined}
          />
        ))}
      </div>
    </div>
  );
};

export default FieldsList;
